<div class="order-cart__popup">
	<div class="popup__close" (click)="closePopup()"></div>
	<div class="order-cart__popup-block row" [ngSwitch]="taskSubmitStatus$ | async">
		<form class="grid row" *ngSwitchCase="'idle'" [formGroup]="form" dir="rtl" (ngSubmit)="handleTaskSubmit()">
			<h2 class="order-cart__popup-title">הפק משימה</h2>
			<ngx-skeleton-loader *ngIf="isLoadingClients$ | async; else clientsLoadedBlock" count="1" appearance="line"></ngx-skeleton-loader>
			<ng-template #clientsLoadedBlock>
				<mat-form-field color="primary">
					<mat-label>בחר לקוח</mat-label>
					<input type="text" placeholder="לקוח" matInput [matAutocomplete]="autoClient" formControlName="client" />
					<mat-autocomplete autoActiveFirstOption #autoClient="matAutocomplete">
						<mat-option *ngFor="let client of allClientsDisplay$ | async" [value]="client.ClientId">
							<span style="unicode-bidi: isolate">{{ client.ClientId }}</span> -
							<span style="unicode-bidi: isolate">{{ client.Client_Name }}</span>
						</mat-option>
					</mat-autocomplete>
					<mat-error>יש לבחור לקוח</mat-error>
				</mat-form-field>
			</ng-template>
			<mat-form-field color="primary">
				<mat-label>בחר תאריך יעד</mat-label>
				<input [min]="today" readonly="true" formControlName="date" matInput [matDatepicker]="picker" (click)="picker.open()" />
				<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
				<mat-datepicker #picker></mat-datepicker>
				<mat-error>יש לבחור תאריך</mat-error>
			</mat-form-field>
			<mat-form-field color="primary" dir="rtl">
				<mat-label dir="rtl">שיוך</mat-label>
				<input type="text" placeholder="נהג" matInput [matAutocomplete]="autoAgent" formControlName="agent" />
				<mat-autocomplete autoActiveFirstOption #autoAgent="matAutocomplete">
					<mat-option *ngFor="let agent of allAgentsDisplay$ | async" [value]="agent.AgentID">
						<span style="unicode-bidi: isolate">{{ agent.AgentID }}</span> -
						<span style="unicode-bidi: isolate">{{ agent.UserName }}</span>
					</mat-option>
				</mat-autocomplete>
				<mat-error>יש לבחור נהג</mat-error>
			</mat-form-field>
			<mat-form-field color="primary">
				<mat-label>הערות למשימה</mat-label>
				<textarea style="min-height: 100px" formControlName="remarks" matInput placeholder="הערות"></textarea>
			</mat-form-field>
			<div class="row gap justify-align-center">
				<button mat-raised-button type="submit" color="primary">צור משימה</button>
				<button mat-raised-button type="button" (click)="closePopup()">ביטול</button>
			</div>
		</form>
		<div class="grid justify-align-center row">
			<mat-spinner *ngSwitchCase="'loading'"></mat-spinner>
			<div *ngSwitchCase="'success'" class="row grid gap">
				<h1 class="valid-color order-cart__popup-title text-align-center">המשימה נוצרה בהצלחה!</h1>
				<div class="order-process__image image" style="width: min(300px, 75vw)">
					<img src="/assets/images/basket/process/save.gif" alt="photo" />
				</div>
				<button mat-raised-button color="primary" (click)="taskSubmitStatus$.next('idle')">אישור</button>
			</div>
			<div *ngSwitchCase="'error'" class="row grid gap">
				<div class="invalid-color">אירעה שגיאה בעת יצירת המשימה, נסו שנית מאוחר יותר</div>
				<button mat-raised-button (click)="taskSubmitStatus$.next('idle')">הבנתי</button>
			</div>
		</div>
	</div>
</div>
